import { SITE_NAME } from "@api/constants";
import { NextSeo } from "next-seo";
import React from "react";

import Container from "@components/Container";
import MainLayout from "@components/MainLayout";
import TermsAndConditions from "@components/TermsAndConditions";
import Title from "@components/Title";

const TermsPage = () => (
  <Container>
    <NextSeo title={`Terms and Conditions | ${SITE_NAME}`} />
    <Title>Terms and Conditions</Title>
    <TermsAndConditions />
  </Container>
);

TermsPage.Layout = MainLayout;

export default TermsPage;
